import type { GlobalState } from '../global/types';

import { loadCache, loadCachedSharedState } from '../global/cache';
import {
  getGlobal, setGlobal,
} from '../global/index';
import { INITIAL_GLOBAL_STATE } from '../global/initialState';
import { cloneDeep } from './iteratees';
import { hasStoredSession } from './sessions';

export async function initGlobal(force: boolean = false, prevGlobal?: GlobalState) {
  prevGlobal = prevGlobal || getGlobal();
  if (!force && 'byTabId' in prevGlobal) {
    return;
  }

  const initial = cloneDeep(INITIAL_GLOBAL_STATE);
  const cache = await loadCache(initial);
  let global = cache || initial;

  if (global.authState === 'authorizationStateReady' && !hasStoredSession()) {
    global = { ...global, authState: 'authorizationStateWaitPhoneNumber' };
  }

  if (force) {
    global.byTabId = prevGlobal.byTabId;
  }

  if (!cache) {
    const storedSharedState = await loadCachedSharedState();
    if (storedSharedState) {
      global.sharedState = storedSharedState;
    }
  }

  setGlobal(global);
}
